export const BRAILLER_QUEUE_STATUS = {
    Pending: 1,
    Waitlist: 2,
    ReadyForProcessing: 3,
    WaitlistProcessing: 4,
    CheckedOut: 5,
    Cancelled: 6,
};

export const BRAILLER_LOAN_STATUS = {
    ReadyForCheckout: 1,
    Waitlist: 2,
    CheckedOut: 3,
    Renewed: 4,
    Returned: 6,
    Lost: 6,
    Damaged: 7,
};

export const braillerQueueModel = ({
    braillerQueueItemIds = [],
    studentId = null,
    shippingLocationId = null,
}: { braillerQueueItemIds?: string[]; studentId?: string | null; shippingLocationId?: string | null } = {}) => ({
    braillerQueueItemIds,
    studentId,
    shippingLocationId,
});

export const emptyBraillerQueueModel = braillerQueueModel();

export const braillerCatalogQueueModel = ({
    braillerCatalogItemId,
    braillerQueueId,
    status,
    catalogNumber,
    inventoryBarCode,
    studentName,
    shippingLocation,
    inventoryItem,
    title,
                                          }: Record<string, unknown> = {}) => ({
    braillerCatalogItemId,
    inventoryItem,
    details: createBraillerQueueDetails({
        status: status as number | undefined,
        catalogNumber: catalogNumber as string | undefined,
        inventoryBarCode: inventoryBarCode as string | undefined,
        studentName: studentName as string | undefined,
        shippingLocationName: (shippingLocation as Record<string, unknown> | undefined)?.name as string | undefined,
        serialNumber: (inventoryItem as Record<string, unknown> | undefined)?.serialNumber as string | undefined,
    }),
    braillerQueueId,
    title,
});

function returnCatalogNumber(catalogNumber: string | null | undefined) {
    return catalogNumber ? `<div><b>${catalogNumber}</b> (Catalog #)</div>` : "";
}

function returnStatus(status: string | number | null | undefined) {
    const statusText: { [key: number]: string } = {
        1: "Pending",
        2: "Waitlist",
        3: "Ready for Processing",
        4: "Waitlist Processing",
        5: "Checked Out",
        6: "Cancelled",
    };
    const key = typeof status === 'number' ? status : Number(status);
    const statusValue = !isNaN(key) ? statusText[key] || "Unknown" : "Unknown";
    return `<div><b>${statusValue}</b> (Status)</div>`;
}

function returnBarcode(inventoryBarCode: string | null | undefined) {
    return inventoryBarCode ? `<div><b>${inventoryBarCode}</b> (Barcode)</div>` : "";
}

function returnStudent(studentName: string | null | undefined) {
    return studentName ? `<div><b>${studentName}</b> (Student)</div>` : "";
}

function returnShipping(shippingLocationName: string | null | undefined) {
    return shippingLocationName ? `<div><b>${shippingLocationName}</b> (Shipping)</div>` : "";
}

function createBraillerQueueDetails({status, catalogNumber, inventoryBarCode, studentName, shippingLocationName, serialNumber}: { status?: string | number | null; catalogNumber?: string | null; inventoryBarCode?: string | null; studentName?: string | null; shippingLocationName?: string | null; serialNumber?: string | null }) {
    let details = "";
    details += returnCatalogNumber(catalogNumber);
    details += returnStatus(status);
    details += returnBarcode(inventoryBarCode);
    details += returnStudent(studentName);
    details += returnShipping(shippingLocationName);
    details += serialNumber ? `<div><b>${serialNumber}</b> (Serial #)</div>` : "";

    return details;
}

export const queueItemModel = (braillerQueueItem: Record<string, unknown> = {}) => {
const braillerInventoryId = braillerQueueItem.braillerInventoryId as string | undefined;
const braillerCatalogItemId = braillerQueueItem.braillerCatalogItemId as string | undefined;
const catalogItem = (braillerQueueItem.braillerCatalogItem || {}) as Record<string, unknown>;
const title = (catalogItem.title as string) || '';
const catalogNumber = catalogItem.catalogNumber as string | undefined;
    const serialNumber = braillerQueueItem.serialNumber as string | undefined;
    const assetNumber = braillerQueueItem.assetNumber as string | undefined;
    const shelfLocation = braillerQueueItem.shelfLocation as string | undefined;
    const status = braillerQueueItem.status as number | undefined;
    const inventoryBarCode = braillerQueueItem.inventoryBarCode as string | undefined;
    const shippingLocationName = braillerQueueItem.shippingLocationName as string | undefined;

    const braillerQueueId = (braillerQueueItem.braillerQueueId as string) || '';

    return {
        ...braillerQueueItem,
        braillerQueueId,
        braillerInventoryId,
        braillerCatalogItemId,
        title,
        catalogNumber,
        serialNumber,
        assetNumber,
        shelfLocation,
        inventoryBarCode,
        shippingLocationName,
        status,
        isPending: status === BRAILLER_QUEUE_STATUS.Pending || status === BRAILLER_QUEUE_STATUS.Waitlist,
        isWaitlisted: status === BRAILLER_QUEUE_STATUS.Waitlist,
        isReadyForProcessing: status === BRAILLER_QUEUE_STATUS.ReadyForProcessing,
        canAssignShipping: status === BRAILLER_QUEUE_STATUS.Pending,
        hasInventoryReserved: braillerInventoryId != null,
    };
};